import { ApiProperty } from "@nestjs/swagger";

export class ReportedStockRequest {
    @ApiProperty()
    saleOrderItemId: number;
}
